import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawPlusIcon from "./RawPlusIcon.svg.jsx";

const PlusIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawPlusIcon} {...props} />;
});

export default PlusIcon;
